import { createActions } from 'redux-actions';
import { batch } from 'react-redux';

import registrationApi from '../../../api/registrationApi';
// eslint-disable-next-line import/no-cycle
import { updateDirectorList } from '../idverification/actions';
// eslint-disable-next-line import/no-cycle
import {
  markCurrentStepAsCompleted,
  resetCurrentStep,
  restartWorkflow,
  markCurrentStepAsCompletedAndGoToNextStep,
  switchToTrusteeWorkflow,
} from '../steps/actions';
import {
  showMainLoading,
  hideMainLoading,
  resetInvitationCode,
  resetInviterRole,
  setInvitedStatus,
  setBrokerInvitedStatus,
} from '../main/actions';
import { ACTION_PREFIX, actionTypes } from './constants';
import { getActionOptions } from '../../../utils/reduxactionsutils';
import {
  selectInvitationCode,
  selectInviterRole,
  selectMainPortal,
  selectUserJourneyAccountType,
  selectMainRegistrationMode,
} from '../../../selectors';
import urlUtils from '../../../utils/urlutils';
import { gtmUserJourneyEvent } from '../../../utils/gtmUtils';
import { GTM_EVENT_TYPE_USER_JOURNEY, QUERY_PARAMS } from '../../../constants';

export const { updateBusinessValidationResult, resetBusinessValidationResult } = createActions(
  actionTypes.UPDATE_BUSINESS_VALIDATION_RESULT,
  actionTypes.RESET_BUSINESS_VALIDATION_RESULT,
  getActionOptions(ACTION_PREFIX),
);

export function checkBusinessEligibility(selectedAbn, isTrustee) {
  return (dispatch, getState) => {
    const state = getState();
    const portal = selectMainPortal(state);
    const userJourneyAccountType = selectUserJourneyAccountType(state);
    const registrationMode = selectMainRegistrationMode(state);

    const setError = (message) => {
      dispatch(
        updateBusinessValidationResult({
          abn: selectedAbn,
          isCompany: false,
          isTrustee,
          isValidated: true,
          isEligible: false,
          message,
          mobileNumberFromInvitation: null,
          canVerifyIdUsingPrefilledDetails: false,
        }),
      );
    };

    batch(() => {
      dispatch(showMainLoading('Checking eligibility...'));
      dispatch(resetBusinessValidationResult());
      dispatch(resetCurrentStep());
    });

    registrationApi
      .checkEligibility(selectedAbn.id, isTrustee, portal, registrationMode)
      .then((response) => {
        const { abn, entityDetails, links, isError, errorMessage, officeHolders } =
          response.data.output;

        if (abn !== selectedAbn.id) {
          return;
        }

        if (isError) {
          setError(errorMessage);
          return;
        }

        if (entityDetails.isValid && entityDetails.isActive) {
          const isCompany = abn && entityDetails.entitySubType.toLowerCase() === 'company';
          const isTrust = abn && entityDetails.entitySubType.toLowerCase() === 'trust';
          batch(() => {
            dispatch(
              updateBusinessValidationResult({
                abn: selectedAbn,
                isCompany,
                isTrustee,
                isTrust,
                isValidated: true,
                isEligible: true,
                message: 'This business is eligible',
                mobileNumberFromInvitation: null,
                canVerifyIdUsingPrefilledDetails: false,
              }),
            );

            const gtmUserJourneyEventObject = {
              eventType: GTM_EVENT_TYPE_USER_JOURNEY.REGO_BUSINESS_SELECTED,
              accountType: userJourneyAccountType,
            };
            gtmUserJourneyEvent(gtmUserJourneyEventObject);

            if (officeHolders && officeHolders.length) {
              dispatch(updateDirectorList(officeHolders));
            }
            if (isTrust) {
              // dispatch update workflow to trustee validation workflow
              dispatch(switchToTrusteeWorkflow());
            }
            if (links && links.length) {
              dispatch(markCurrentStepAsCompleted({ nextStepLinks: links }));
            }
          });
        } else if (!entityDetails.isActive) {
          setError(entityDetails.message);
        } else {
          setError(entityDetails.message || errorMessage);
        }
      })
      // eslint-disable-next-line no-unused-vars
      .catch((_reason) => {
        setError('Something went wrong while checking eligibility');
      })
      .finally(() => dispatch(hideMainLoading()));
  };
}

export function verifyInvitation(portal, recipientGcContactId) {
  return async (dispatch, getState) => {
    const state = getState();
    let invitationCode = selectInvitationCode(state);
    let inviterRole = selectInviterRole(state);

    if (!invitationCode) {
      invitationCode = urlUtils.getSessionQuerystring(QUERY_PARAMS.INVITATION_CODE);
    }
    if (!inviterRole) {
      inviterRole = urlUtils.getSessionQuerystring(QUERY_PARAMS.INVITER_ROLE);
    }
    if (invitationCode) {
      batch(() => {
        dispatch(showMainLoading('Verifying invitation details...'));
        dispatch(resetInvitationCode());
        dispatch(resetInviterRole());
      });
      registrationApi
        .verifyInvite(invitationCode, inviterRole, portal, recipientGcContactId)
        .then((response) => {
          const {
            abn,
            isError,
            links,
            mobile,
            canVerifyIdUsingPrefilledDetails,
            isKycCompleted,
            redirectUrl,
          } = response.data.output;
          if (!isError) {
            if (isKycCompleted) {
              setTimeout(() => {
                // eslint-disable-next-line no-undef
                window.location = redirectUrl;
              }, 300);
            } else {
              const selectedAbn = {
                id: abn,
              };
              batch(() => {
                dispatch(
                  updateBusinessValidationResult({
                    abn: selectedAbn,
                    isValidated: true,
                    isEligible: true,
                    message: 'This business is eligible',
                    mobileNumberFromInvitation: mobile,
                    canVerifyIdUsingPrefilledDetails,
                  }),
                );
                dispatch(setInvitedStatus());
                if (urlUtils.isBrokerOnboarding()) {
                  dispatch(setBrokerInvitedStatus());
                }
              });
              if (links && links.length) {
                dispatch(markCurrentStepAsCompletedAndGoToNextStep(links));
              } else {
                dispatch(restartWorkflow());
              }
              dispatch(hideMainLoading());
            }
          } else {
            dispatch(hideMainLoading());
          }
        })
        .catch(() => {
          dispatch(hideMainLoading());
          dispatch(restartWorkflow());
        });
    }
  };
}
